import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { orpc } from '@/api/rpc/client';
import { useDebounce } from '@/hooks/useDebounce';

/** One page is enough for a quick-reference list; search narrows past it. */
const LIST_PAGE_SIZE = 50;
const SEARCH_DEBOUNCE_MS = 300;

/**
 * Debounced `listAll` search shared by the compare picker and the comparison
 * panel so those two surfaces stay on one query shape.
 */
export function usePricelistListSearch() {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search.trim(), SEARCH_DEBOUNCE_MS);

  const listQuery = useQuery(
    orpc.inventoryManagement.pricelist.listAll.queryOptions({
      input: {
        page: 1,
        pageSize: LIST_PAGE_SIZE,
        search: debouncedSearch === '' ? undefined : debouncedSearch,
      },
    }),
  );

  return {
    search,
    setSearch,
    listQuery,
    documents: listQuery.data?.documents ?? [],
    totalCount: listQuery.data?.totalCount ?? 0,
  };
}
